// Copyright 2026. WebPros International GmbH. All rights reserved.

import { RootState } from 'client/core/store';
import { ComputeResourceVmStatus } from 'common/api/resources/ComputeResourceVm';

export const isServerSectionAvailable = (state: RootState): boolean =>
    ![ComputeResourceVmStatus.NOT_EXIST.toString(), ComputeResourceVmStatus.UNAVAILABLE.toString()].includes(state.project.servers.item.status);
